import React, { useEffect } from 'react'
import DatasetManageContent from '../../DatasetManageContent/DatasetManageContent'

interface DatasetSpecificContentProps {
  datasetSource: string
  itemsPerPage?: number
}

const DatasetSpecificContent: React.FC<DatasetSpecificContentProps> = ({
  datasetSource,
  itemsPerPage = 200,
}) => {
  // Pass the dataset source directly to DatasetManageContent instead of setting global state
  return <DatasetManageContent itemsPerPage={itemsPerPage} datasetSources={[datasetSource]} />
}

export default DatasetSpecificContent
